// Test IDs for the admin panel.
export const ADMIN = {
    loginForm: 'admin-login-form',
    loginEmail: 'admin-login-email',
    loginPassword: 'admin-login-password',
    loginSubmit: 'admin-login-submit',
    loginError: 'admin-login-error',
    panel: 'admin-panel',
    leadsTable: 'admin-leads-table',
    leadsCount: 'admin-leads-count',
    logoutButton: 'admin-logout-button',
};
